export const EMAIL_COMPOSITION_DIALOG = "emailComposition"
export const SEARCH_EMAIL_TYPE = "searchResultEmail"
export const COURSE_EMAIL_TYPE = "courseTeamEmail"
export const LEARNER_EMAIL_TYPE = "learnerEmail"
export const AUTOMATIC_EMAIL_ADMIN_TYPE = "automaticEmailAdmin"
